import Vue from "vue";
Vue.component("party-selector", {
    props: [
        "value",
        "values",
        "language",
        "disabled",
        "selectAll",
        "multiple",
        "placeholder"
    ],
    data() {
        return {
            loading: false,
            myValues: this.values,
            myValue: this.value,
            filteredParties: [],
            parties: [],
            initializing: false,
            loadingText: window.labels.loading,
            isDisabled: this.disabled
        }
    },
    methods: {
        getFilteredMembers(text) {
            this.filteredParties = this.parties.filter((member) => {
                return member.text
                    .toString()
                    .toLowerCase()
                    .indexOf(text.toLowerCase()) >= 0
            })
        }
    },
    watch: {
        selectAll: function (val) {

            if (val == true) {
                this.myValues = [];
                this.parties.forEach(member => {
                    this.myValues.push(member);

                });
            } else {
                this.myValues = [];
            }
        },

        myValues: function (values) {
            const self = this;

            let tempValues = [];
            values.forEach(member => {
                tempValues.push(member);
            });
            self.$emit("update:values", tempValues);
        },
        myValue: function (value) {
            const self = this;
            self.$emit("update:value", value);
        }
    },
    mounted() {
        const self = this;

        self.loading = true;
        self.isDisabled = false;
        self.$services.parties.getDropdownItems({
            language: self.language,
            includeWto: false,
            published: true
        }).then((data) => {
            self.loading = false;
            self.parties = data;

            self.filteredParties = data;
            if (self.value && self.value.length > 0) {
                self.value.forEach(memberId => {
                    var items = data.filter(member => member.id == memberId);
                    if (items.length > 0) {
                        self.myValues.push(items[0]);
                    }
                });
            }
        });
    },
    template: `
		<div>
			<div v-if="loading">
				<loading :loading-text="loadingText"></loading>
			</div>
			<div v-else>
				<div v-if="multiple">
					<div v-if="selectAll">
						<b-taginput
							disabled
							ref="partyMultiselect"
							autocomplete
                            :placeholder="placeholder"
							v-model.sync="myValues"
							:data="filteredParties"
							@typing="getFilteredMembers"
							field="text"
							:open-on-focus="true">
						</b-taginput>
					</div>
					<div v-else>
						<b-taginput
							ref="partyMultiselect"
							autocomplete
                            :placeholder="placeholder"
							v-model.sync="myValues"
							:data="filteredParties"
							@typing="getFilteredMembers"
							field="text"
							:open-on-focus="true">
						</b-taginput>
					</div>
				</div>
				<div v-else>
					<b-select :disabled="isDisabled" :placeholder="placeholder" v-model="myValue" expanded>
						<option v-for="party in filteredParties" :key="party.id"
							:value="party">{{ party.text }}
						</option>
					</b-select>                    
				</div>
			</div>
		</div>
	`
});